import { Coins, Crown, Dices, Spade, Diamond, Heart, Club, Star, Gem, Flame, Trophy } from "lucide-react";

const Seven = ({ className }) => <span className={`${className} font-casino leading-none flex items-center justify-center text-[0.95em]`}>7</span>;

export const AVATARS = {
  chip: { icon: Coins, bg: "#C8102E" },
  crown: { icon: Crown, bg: "#B8862B" },
  dice: { icon: Dices, bg: "#1F6FEB" },
  spade: { icon: Spade, bg: "#111111" },
  diamond: { icon: Diamond, bg: "#0E7C66" },
  heart: { icon: Heart, bg: "#9B111E" },
  club: { icon: Club, bg: "#2B2B2B" },
  star: { icon: Star, bg: "#7A4FD6" },
  gem: { icon: Gem, bg: "#0B7285" },
  flame: { icon: Flame, bg: "#D9480F" },
  trophy: { icon: Trophy, bg: "#8A6D1D" },
  seven: { icon: Seven, bg: "#5C0A14" },
};
export const AVATAR_IDS = Object.keys(AVATARS);

export const Avatar = ({ id, size = 32, testid }) => {
  const a = AVATARS[id] || AVATARS.chip;
  const Icon = a.icon;
  return (
    <span data-testid={testid} className="inline-flex items-center justify-center rounded-full shrink-0 border border-gold/60 shadow-[0_0_10px_rgba(232,181,74,0.25)]"
      style={{ width: size, height: size, background: `radial-gradient(circle at 35% 30%, ${a.bg}, #0b0705 95%)` }}>
      <Icon className="text-[#F7D77E]" style={{ width: size * 0.5, height: size * 0.5 }} />
    </span>
  );
};
